import {gql} from "@apollo/client";

const chatGroupQuery = gql`
    query ChatGroupQuery(
        $opponentId: String
        $universitySlug: String
        $isDegreeTypesEnabled: Boolean = false
    ) {
        chatGroup(opponentId: $opponentId, universitySlug: $universitySlug) {
            id
            lastMessage {
                text
                created
            }
            unreadMessageCount
            members {
                id
            }
            opponent {
                id
                firstName
                inboxInfoOne
                inboxInfoTwo
                profilePhoto
                accountRole
                isOnline
                degrees @include(if: $isDegreeTypesEnabled) {
                    degreeType
                    degree {
                        id
                        name
                    }
                }
            }
            members {
                id
                isOnline
            }
        }
    }
`;

export default chatGroupQuery;
